import ApiBase from '../ApiBase';

class SiteConfig extends ApiBase {
    route = '/site-config';
};

export default new SiteConfig();

/*
Example...

import SiteConfigApi from 'Services/Api/SiteConfig/SiteConfig';
import {Socket} from 'Services';

componentDidMount = async () => {
    this.loadPhase();
    this.subscribeToPhaseBroadcasts();
}

componentWillUnmount = () => {
    Socket.echo.leave('site_config');
 }

loadPhase = async () => {
    const response = await SiteConfigApi.get(null, {
        key: 'phase'
    });

    this.handlePhaseChange(parseInt(response.data.data[0].value));
 }

subscribeToPhaseBroadcasts = () => {
    Socket.getConnection()
        .private('site_config')
        .listen('SiteConfigUpdated', (e) => {
            if (e.siteConfig.key !== 'phase') {
                return;
            }

            this.handlePhaseChange(parseInt(e.siteConfig.value));
        });
 }

 handlePhaseChange = (phase) => {
    this.setState({
        phase
    });
 }
 */